module.exports = __webpack_public_path__ + "static/solomon_motors_1987-b95632c14f16a42e4b7e6eb9445fcc5c.jpg";